module.exports = __webpack_public_path__ + "img/p4_3.1a81d182.webp";